import { motion } from "motion/react";
import styles from "./FloatingChit.module.css";

export function FloatingChit({
  color,
  delay,
  duration,
  x,
  y,
  rotate,
  icon,
}) {
  return (
    <motion.div
      className={`${styles.chit} ${styles[color]}`}
      style={{ left: `${x}%`, top: `${y}%` }}
      initial={{ opacity: 0, scale: 0, rotate: 0 }}
      animate={{
        opacity: [0, 1, 1, 0],
        scale: [0, 1, 1, 0],
        rotate: [0, rotate, rotate, 0],
        y: [0, -100, -200, -300],
      }}
      transition={{
        duration,
        delay,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    >
      {icon}
    </motion.div>
  );
}
